<template>
  <footer class="container-fluid">
    <div class="row">
      <div class="footer-mobile col-12">
        <div class="row top">
          <div class="container">
            <div class="row">
              <div class="col-6 contacts-mobile">
                <ul>
                  <li>
                    <h5>Контакты</h5>
                    <ul>
                      <li>
                        <h6>Отель:</h6>
                        <a href="tel:7-940-962-1100">
                          <div>+7 (940) 962-11-00</div>
                        </a>
                      </li>
                      <li>
                        <h6>Ресторан:</h6>
                        <a href="tel:7-940-707-1100">
                          <div>+7 (940) 707-11-00</div>
                        </a>
                      </li>
                      <li>
                        <h6>E-mail:</h6>
                        <a href="mailto:leon-hotel@mail.ru">
                          <div>leon-hotel@mail.ru</div>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <h5>Адрес</h5>
                    <p>
                      Абхазия, г. Сухум,
                      <br />ул. Читанава, д.6
                    </p>
                  </li>
                </ul>
              </div>
              <div class="col-6 footer-logo-mobile">
                <img src="/img/logo_full.svg" alt />
              </div>
            </div>
            <div class="row">
              <div class="col-12 social-mobile">
                <ul>
                  <li class="social">
                    <a href="https://www.facebook.com/LeonHotel.abkhazia" target="_blank">
                      <img src="/img/facebook.svg" alt />
                    </a>
                  </li>
                  <li class="social">
                    <a href="https://api.whatsapp.com/send?phone=79409621100" target="_blank">
                      <img src="/img/whatsapp.svg" alt />
                    </a>
                  </li>
                  <li class="social">
                    <a href="https://www.instagram.com/hotel_restaurant_leon" target="_blank">
                      <img src="/img/instagram.svg" alt />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row bottom">
          <div class="container">
            <div class="col-12 created-mobile">
              Разработка
              <a href="https://a-it.org" >AIT</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-desktop col-12">
      <div class="container-fluid">
        <div class="contaniner-content">
          <div class="footer-img">
            <img src="/img/logo-leon.svg" alt />
          </div>
          <div class="contacts">
            <ul>
              <li>
                <h5>Контакты</h5>
                <ul>
                  <li>
                    <h6>Отель:</h6>
                    <a href="tel: +79409621100">
                      <div>+7 (940) 962-11-00</div>
                    </a>
                  </li>

                  <li>
                    <h6>Ресторан:</h6>
                    <a href="tel: +79407071100">
                      <div>+7 (940) 707-11-00</div>
                    </a>
                  </li>

                  <li>
                    <h6>E-mail:</h6>
                    <a href="mailto: leon-hotel@mail.ru">
                      <div>leon-hotel@mail.ru</div>
                    </a>
                  </li>
                </ul>
              </li>

              <!-- <li>
                <a href="/contacts#vacancy">
                  <div>Вакансии</div>
                </a>
              </li> -->
            </ul>
          </div>

          <div class="adress">
            <ul>
              <li>
                <h5>Адрес</h5>
                <p style="font-size:16px;">
                  Абхазия, г. Сухум,
                  <br />ул. Читанава, д.6
                </p>
              </li>
            </ul>
          </div>

          <div class="stay">
            <h5>Оставайтесь с нами</h5>

            <div class="social_row">
              <a href="https://www.facebook.com/LeonHotel.abkhazia" target="_blank">
                <img src="/img/facebook.svg" alt />
              </a>

              <a href="https://api.whatsapp.com/send?phone=79409621100" target="_blank">
                <img src="/img/whatsapp.svg" alt />
              </a>
              <a href="https://www.instagram.com/hotel_restaurant_leon" target="_blank">
                <img src="/img/instagram.svg" alt />
              </a>
            </div>
          </div>
        </div>

        <div class="created">
          Разработка
          <a href="https://a-it.org">AIT</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
footer {
  overflow-x: hidden;
}

footer {
  background-color: #e5e3e0;
  position: relative;
}

.footer-mobile {
  display: none !important;
}

.footer-desktop {
  display: block !important;
}

.footer-desktop {
  height: 434px;
  background: #e5e3e0;
  padding: 105px 285px;
  position: relative;
}


footer div.container-fluid {
  height: 100%;
  width: 100%;

}

footer div.contaniner-content {
  display: flex;
  justify-content: space-between;
}

ul {
  list-style-type: none;
  display: flex;
  flex-wrap: nowrap;
  margin: 0;
  padding: 0;
}

.left-nav ul li a {
  color: white;
  text-decoration: none;
  font-family: "Lato";
  font-size: 2rem;
  text-decoration: none;
}

.social_row {
  display: flex;
}

.social_row a img {
  height: 30px;
  width: 30px;
  margin-right: 18.5px;
  // margin-left: 20px;
  // filter: invert(1);
  margin-top: 10px;
  // margin-top: 20px;
}

.social-mobile .social_row a img:first-child {
  margin-left: 2px;
}

.social-mobile .social a img[src="/img/whatsapp.svg"] {
  height: 31px;
  width: 31px;
  margin-top: 19px !important;
}

.contacts ul {
  display: flex;
  flex-direction: column;
}

.contacts ul li h5 {
  font-size: 24px;
  font-family: "Lato";
  font-weight: 400;
  color: #3e3e3e;
}

.contacts ul li h6 {
  font-size: 16px;
  font-family: "Lato";
  font-weight: 400;
  color: #3e3e3e;
}

.adress ul li h5 {
  font-size: 24px;
  font-family: "Lato";
  font-weight: 400;
  color: #3e3e3e;
}

.contacts ul li {
  margin-bottom: -3px;
}

.contacts ul li a {
  font-size: 16px;
  font-family: "Lato";
  font-weight: 400;
  color: #3e3e3e;
}

.stay h5 {
  font-size: 24px;
  font-family: "Lato";
  font-weight: 400;
  color: #3e3e3e;
}

.created {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  bottom: 20px;
  text-align: center;
  font-weight: normal;
  font-family: "Lato";
  font-size: 19px;
  color: #948e81;
}

.created a {
  font-family: "Lato";
  font-size: 19px;
  color: #948e81;
  text-decoration: none !important;
}

@media screen and (max-width: 1799px) {
  .footer-desktop {
    padding: 105px 240px;
  }
}

@media screen and (max-width: 1700px) {
  .footer-desktop {
    padding: 105px 200px;
  }
}

@media screen and (max-width: 1500px) {
  .footer-desktop {
    padding: 105px 135px;
  }
}

@media screen and (max-width: 1350px) {
  .footer-desktop {
    padding: 105px 75px;
  }
}


@media screen and (max-width: 1100px) {
  .footer-desktop {
    display: none !important;
  }

  .footer-mobile {
    display: block !important;
    background: #4b3f3f;
  }

  .footer {
    background: #4b3f3f;
  }

  .social a img {
    height: 29px;
    width: 29px;
    margin-left: 20px;
    filter: invert(1);
    margin-top: -4px;
    margin-top: 20px;
  }

  .social a img[src="/img/whatsapp.svg"] {
    height: 31px;
    width: 31px;
    margin-top: 19px !important;
  }


}

@media screen and (max-width: 360px) {
  .container-fluid {
    padding: 0;
  }
}
</style>

<style lang="scss" scoped>
// .footer-desktop {
//   display: none !important;
// }
// .footer-mobile {
//   display: block !important;
// }
.footer-mobile {
  height: 382px;
}

.footer-mobile .top {
  height: 340px;
}

.footer-mobile .bottom {
  height: 42px;
  border-top: 2px solid #d9ccaf !important;
}

.bottom .container {
  display: flex;
}

.created-mobile {
  text-align: center;
  color: #d9ccaf;
  font-size: 9px;
  margin: auto;
  padding-bottom: 1px;
}

.created-mobile a {
  color: white;
  font-size: 9px;
  text-decoration: underline;
}

.contacts-mobile {
  height: 283px;
  max-height: 283px;
  padding-left: 50px;
}

.contacts-mobile ul {
  display: flex;
  flex-direction: column;
}

.contacts-mobile ul li h5,
.contacts-mobile ul li h6 {
  margin: 0;
}

.contacts-mobile ul li h5 {
  font-size: 15px;
  font-family: "Lato";
  margin-top: 30px;
  color: white;
}

.contacts-mobile ul li a,
.contacts-mobile ul li p,
.contacts-mobile ul li h6 {
  font-size: 12px;
  font-family: "Lato";
  margin-top: 5px;
  color: white;
}

.contacts-mobile ul li p {
  line-height: 15px;
}

.contacts-mobile ul li h6 {
  margin-bottom: -8px;
}

.footer-logo-mobile {
  display: flex;
  height: 283px;
  max-height: 283px;
}

.footer-logo-mobile img {
  height: 153px;
  width: 115px;
  margin: auto;
  margin-right: 50px;
}

.social-mobile {
  height: 57px;
}

.social-mobile ul {
  text-align: center;
  justify-content: center;
}

.social-mobile ul li.social:last-child a img {
  margin-right: 0 !important;
}

.social-mobile .social a img {
  height: 19px !important;
  width: 19px !important;
  margin-top: 19px !important;
  margin-left: 0;
  margin: 5px;
}





@media (min-width: 1200px) {
  // .contacts ul {
  //   display: flex;
  //   flex-direction: column;
  // }
  // .contacts ul li h5 {
  //   font-size: 24px;
  //   font-family: "Lato";
  //   font-weight: 400;
  //   color: #3e3e3e;
  // }

  // .adress ul li h5 {
  //   font-size: 24px;
  //   font-family: "Lato";
  //   font-weight: 400;
  //   color: #3e3e3e;
  // }
  // .contacts ul li {
  //  margin-bottom: -3px;
  // }

  // .contacts ul li a {
  //   font-size: 16px;
  //   font-family: "Lato";
  //   font-weight: 400;
  //   color: #3e3e3e;
  // }

  // .stay h5 {
  //   font-size: 24px;
  //   font-family: "Lato";
  //   font-weight: 400;
  //   color: #3e3e3e;
  // }
  // .stay {
  //   padding-right: 135px;
  //   height: 283px;
  //   max-height: 283px;
  //   text-align: right;
  // }
  // .stay ul {
  //   flex-direction: row-reverse;
  // }
  // .contacts ul {
  //   display: flex;
  //   flex-direction: column;
  // }
  // .contacts ul li h5,
  // .contacts ul li h6 {
  //   margin: 0;
  // }
  // .contacts ul li h5 {
  //   font-size: 24px;
  //   font-family: "Lato";
  //   margin-top: 30px;
  //   color: white;
  // }
  // .contacts ul li a,
  // .contacts ul li p,
  // .contacts ul li h6 {
  //   font-size: 21px;
  //   font-family: "Lato";
  //   margin-top: 20px;
  //   color: white;
  //   line-height: 28px;
  // }
  // .contacts ul li p {
  //   line-height: 28px;
  // }

  // .contacts ul li h6 {
  //   margin-bottom: -8px;
  // }
}

// @media (max-width: 1199px) {
//   .footer-desktop {
//     display: none !important;
//   }
//   .footer-mobile {
//     display: block !important;
//   }
//   .footer-mobile {
//     height: 382px;
//   }
//   .footer-mobile .top {
//     height: 340px;
//   }
//   .footer-mobile .bottom {
//     height: 42px;
//     border-top: 2px solid #d9ccaf !important;
//   }
//   .bottom .container {
//     display: flex;
//   }
//   .created-mobile {
//     text-align: center;
//     color: #d9ccaf;
//     font-size: 9px;
//     margin: auto;
//     padding-bottom: 1px;
//   }
//   .created-mobile a {
//     color: white;
//     font-size: 9px;
//     text-decoration: underline;
//   }
//   .contacts-mobile {
//     height: 283px;
//     max-height: 283px;
//     padding-left: 50px;
//   }
//   .contacts-mobile ul {
//     display: flex;
//     flex-direction: column;
//   }
//   .contacts-mobile ul li h5,
//   .contacts-mobile ul li h6 {
//     margin: 0;
//   }
//   .contacts-mobile ul li h5 {
//     font-size: 15px;
//     font-family: "Lato";
//     margin-top: 30px;
//     color: white;
//   }
//   .contacts-mobile ul li a,
//   .contacts-mobile ul li p,
//   .contacts-mobile ul li h6 {
//     font-size: 12px;
//     font-family: "Lato";
//     margin-top: 5px;
//     color: white;
//   }
//   .contacts-mobile ul li p {
//     line-height: 15px;
//   }

//   .contacts-mobile ul li h6 {
//     margin-bottom: -8px;
//   }
//   .footer-logo-mobile {
//     display: flex;
//     height: 283px;
//     max-height: 283px;
//   }
//   .footer-logo-mobile img {
//     height: 153px;
//     width: 115px;
//     margin: auto;
//     margin-right: 50px;
//   }
//   .social-mobile {
//     height: 57px;
//   }
//   .social-mobile ul {
//     text-align: center;
//     justify-content: center;
//   }
//   .social-mobile ul li.social:last-child a img {
//     margin-right: 0 !important;
//   }
//   .social-mobile .social a img {
//     height: 19px !important;
//     width: 19px !important;
//     margin-top: 19px !important;
//     margin-left: 0;
//     margin: 5px;
//   }
// }

footer a {
  text-decoration: none;
}

footer a div {
  margin-top: 3px;
}
</style>

<style>
.social a img[src="/img/whatsapp.svg"] {
  height: 31px;
  width: 31px;
  margin-top: -5px;
}
</style>
